import { Drawer as AntDDrawer, DrawerProps as AntDDrawerProps } from "antd";

export const Drawer = (props: AntDDrawerProps) => <AntDDrawer {...props} />;
